// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","text":"Footer_text__27sON"};